import { useEffect, useState } from 'react'
import { AssetEntityDetails, AssetInventoryType } from 'models'
import { AssetInventoryServiceV4 } from 'services'

/**
 * Details for the selected row. The grid row already holds every resolved value, so a failure
 * here costs the evidence behind the values, not the values themselves — the pane stays usable.
 */
export const useAssetEntity = (assetType: AssetInventoryType, entityId: string | null) => {
  const [details, setDetails] = useState<AssetEntityDetails | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setDetails(null)

    if (!entityId) return

    let cancelled = false
    setLoading(true)

    AssetInventoryServiceV4.getEntity(assetType, entityId)
      .then((next) => !cancelled && setDetails(next))
      .catch((err) => console.error(err))
      .finally(() => !cancelled && setLoading(false))

    return () => {
      cancelled = true
    }
  }, [assetType, entityId])

  return { details, loading }
}
